import { MenuSection as OriginalComponent } from './MenuSection';

export const MenuSection = OriginalComponent;



// WEBPACK FOOTER //
// ./app/components/MenuSection/index.js